import { render, staticRenderFns } from "./TireLocationNoTableField.vue?vue&type=template&id=23c66d02&scoped=true"
import script from "./TireLocationNoTableField.vue?vue&type=script&lang=ts"
export * from "./TireLocationNoTableField.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23c66d02",
  null
  
)

export default component.exports